/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryReturnType,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AddTeacherToSchoolClassParams,
  Invite,
  InviteInput,
  ListProjectAuditsParams,
  ListProjectItemsParams,
  ListProjectsParams,
  ListPupilsParams,
  ListSchoolClassInvitesParams,
  ListSchoolClassMembershipsParams,
  ListSchoolClassesParams,
  PaginatedInvites,
  PaginatedProjectAudits,
  PaginatedProjectItems,
  PaginatedProjects,
  PaginatedPupils,
  PaginatedSchoolClassMemberships,
  PaginatedSchoolClasses,
  Project,
  ProjectAttachment,
  ProjectAttachmentRequestInput,
  ProjectAvailableTeachersCollection,
  ProjectItem,
  ProjectItemInput,
  ProjectMembership,
  ProjectMembershipRequestInput,
  ProjectMembershipsCollection,
  ProjectRequestInput,
  Pupil,
  ResumeProjectInput,
  SchemaValidationErrorResponse,
  SchoolClass,
  SchoolClassCreateInput,
  SchoolClassInviteJoinError,
  SchoolClassInvitePreview,
  SchoolClassInviteRedeemResult,
  SchoolClassJoinInput,
  SchoolClassMembership,
  SchoolClassMembershipsInput,
  SchoolClassUpdateInput,
  UserUnion,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create ProjectItem
 */
export const createProjectItem = (
    projectItemInput: MaybeRefOrGetter<ProjectItemInput>,
 signal?: AbortSignal
) => {
      projectItemInput = toValue(projectItemInput);

      return axiosClient<ProjectItem>(
      {url: `/project_items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectItemInput, signal
    },
      );
    }




export const getCreateProjectItemMutationKey = () => ['createProjectItem'] as const;

export const getCreateProjectItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,CreateProjectItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,CreateProjectItemMutationVariables, TContext> => {

const mutationKey = getCreateProjectItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectItem>>, CreateProjectItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProjectItem(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectItemMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectItem>>>
    export type CreateProjectItemMutationBody = ProjectItemInput
    export type CreateProjectItemMutationError = ErrorType<void>
    export type CreateProjectItemMutationVariables = {data: ProjectItemInput}

    /**
 * @summary Create ProjectItem
 */
export const useCreateProjectItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,CreateProjectItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createProjectItem>>,
        TError,
        CreateProjectItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectItemMutationOptions(options), queryClient);
    }
    /**
 * @summary List ProjectItems
 */
export const listProjectItems = (
    params?: MaybeRefOrGetter<ListProjectItemsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedProjectItems>(
      {url: `/project_items`, method: 'GET',
        params, signal
    },
      );
    }




export const getListProjectItemsQueryKey = (params?: MaybeRefOrGetter<ListProjectItemsParams>,) => {
    return [
    'project_items', ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectItemsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectItems>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListProjectItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectItems>>> = ({ signal }) => listProjectItems(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData>
}

export type ListProjectItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectItems>>>
export type ListProjectItemsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List ProjectItems
 */

export function useListProjectItems<TData = Awaited<ReturnType<typeof listProjectItems>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListProjectItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete ProjectItem
 */
export const deleteProjectItem = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/project_items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProjectItemMutationKey = () => ['deleteProjectItem'] as const;

export const getDeleteProjectItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,DeleteProjectItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,DeleteProjectItemMutationVariables, TContext> => {

const mutationKey = getDeleteProjectItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectItem>>, DeleteProjectItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProjectItem(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectItem>>>

    export type DeleteProjectItemMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteProjectItemMutationVariables = {id: string}

    /**
 * @summary Delete ProjectItem
 */
export const useDeleteProjectItem = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,DeleteProjectItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProjectItem>>,
        TError,
        DeleteProjectItemMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectItemMutationOptions(options), queryClient);
    }
    /**
 * @summary ProjectItem Detail
 */
export const getProjectItem = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ProjectItem>(
      {url: `/project_items/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetProjectItemQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'project_items',id
    ] as const;
    }


export const getGetProjectItemQueryOptions = <TData = Awaited<ReturnType<typeof getProjectItem>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProjectItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectItem>>> = ({ signal }) => getProjectItem(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData>
}

export type GetProjectItemQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectItem>>>
export type GetProjectItemQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary ProjectItem Detail
 */

export function useGetProjectItem<TData = Awaited<ReturnType<typeof getProjectItem>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectItemQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Project
 */
export const deleteProject = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProjectMutationKey = () => ['deleteProject'] as const;

export const getDeleteProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext> => {

const mutationKey = getDeleteProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, DeleteProjectMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteProject(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteProjectMutationVariables = {id: string}

    /**
 * @summary Delete Project
 */
export const useDeleteProject = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,DeleteProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        DeleteProjectMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Project Details
 */
export const getProject = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Project>(
      {url: `/projects/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetProjectQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'projects',id
    ] as const;
    }


export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProjectQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Project Details
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Project
 */
export const updateProject = (
    id: MaybeRefOrGetter<string>,
    projectRequestInput: MaybeRefOrGetter<ProjectRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
projectRequestInput = toValue(projectRequestInput);

      return axiosClient<void>(
      {url: `/projects/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: projectRequestInput, signal
    },
      );
    }




export const getUpdateProjectMutationKey = () => ['updateProject'] as const;

export const getUpdateProjectMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext> => {

const mutationKey = getUpdateProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, UpdateProjectMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateProject(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = ProjectRequestInput
    export type UpdateProjectMutationError = ErrorType<void | ValidationError>
    export type UpdateProjectMutationVariables = {id: string;data: ProjectRequestInput}

    /**
 * @summary Update Project
 */
export const useUpdateProject = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,UpdateProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        UpdateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Project audits
 */
export const listProjectAudits = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectAuditsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<PaginatedProjectAudits>(
      {url: `/projects/${id}/audits`, method: 'GET',
        params, signal
    },
      );
    }




export const getListProjectAuditsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectAuditsParams>,) => {
    return [
    'projects',id,'audits', ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectAuditsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectAudits>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectAuditsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectAudits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectAuditsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectAudits>>> = ({ signal }) => listProjectAudits(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectAudits>>, TError, TData>
}

export type ListProjectAuditsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectAudits>>>
export type ListProjectAuditsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Project audits
 */

export function useListProjectAudits<TData = Awaited<ReturnType<typeof listProjectAudits>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectAuditsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectAudits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectAuditsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Finish Project
 */
export const finishProject = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${id}/finish`, method: 'PUT', signal
    },
      );
    }




export const getFinishProjectMutationKey = () => ['finishProject'] as const;

export const getFinishProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,FinishProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,FinishProjectMutationVariables, TContext> => {

const mutationKey = getFinishProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishProject>>, FinishProjectMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  finishProject(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishProjectMutationResult = NonNullable<Awaited<ReturnType<typeof finishProject>>>

    export type FinishProjectMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type FinishProjectMutationVariables = {id: string}

    /**
 * @summary Finish Project
 */
export const useFinishProject = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,FinishProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof finishProject>>,
        TError,
        FinishProjectMutationVariables,
        TContext
      > => {
      return useMutation(getFinishProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Pause Project
 */
export const pauseProject = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${id}/pause`, method: 'PUT', signal
    },
      );
    }




export const getPauseProjectMutationKey = () => ['pauseProject'] as const;

export const getPauseProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,PauseProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,PauseProjectMutationVariables, TContext> => {

const mutationKey = getPauseProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseProject>>, PauseProjectMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  pauseProject(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof pauseProject>>>

    export type PauseProjectMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type PauseProjectMutationVariables = {id: string}

    /**
 * @summary Pause Project
 */
export const usePauseProject = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,PauseProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pauseProject>>,
        TError,
        PauseProjectMutationVariables,
        TContext
      > => {
      return useMutation(getPauseProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Restore Project
 */
export const restoreProject = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${id}/restore`, method: 'PUT', signal
    },
      );
    }




export const getRestoreProjectMutationKey = () => ['restoreProject'] as const;

export const getRestoreProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,RestoreProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,RestoreProjectMutationVariables, TContext> => {

const mutationKey = getRestoreProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreProject>>, RestoreProjectMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  restoreProject(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreProjectMutationResult = NonNullable<Awaited<ReturnType<typeof restoreProject>>>

    export type RestoreProjectMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RestoreProjectMutationVariables = {id: string}

    /**
 * @summary Restore Project
 */
export const useRestoreProject = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,RestoreProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof restoreProject>>,
        TError,
        RestoreProjectMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Resume Project
 */
export const resumeProject = (
    id: MaybeRefOrGetter<string>,
    resumeProjectInput: MaybeRefOrGetter<ResumeProjectInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
resumeProjectInput = toValue(resumeProjectInput);

      return axiosClient<void>(
      {url: `/projects/${id}/resume`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resumeProjectInput, signal
    },
      );
    }




export const getResumeProjectMutationKey = () => ['resumeProject'] as const;

export const getResumeProjectMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,ResumeProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,ResumeProjectMutationVariables, TContext> => {

const mutationKey = getResumeProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeProject>>, ResumeProjectMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  resumeProject(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeProjectMutationResult = NonNullable<Awaited<ReturnType<typeof resumeProject>>>
    export type ResumeProjectMutationBody = ResumeProjectInput
    export type ResumeProjectMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type ResumeProjectMutationVariables = {id: string;data: ResumeProjectInput}

    /**
 * @summary Resume Project
 */
export const useResumeProject = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,ResumeProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resumeProject>>,
        TError,
        ResumeProjectMutationVariables,
        TContext
      > => {
      return useMutation(getResumeProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Save Project as Template
 */
export const saveProjectAsTemplate = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${id}/save_as_template`, method: 'PUT', signal
    },
      );
    }




export const getSaveProjectAsTemplateMutationKey = () => ['saveProjectAsTemplate'] as const;

export const getSaveProjectAsTemplateMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveProjectAsTemplate>>, TError,SaveProjectAsTemplateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveProjectAsTemplate>>, TError,SaveProjectAsTemplateMutationVariables, TContext> => {

const mutationKey = getSaveProjectAsTemplateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveProjectAsTemplate>>, SaveProjectAsTemplateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  saveProjectAsTemplate(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveProjectAsTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof saveProjectAsTemplate>>>

    export type SaveProjectAsTemplateMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type SaveProjectAsTemplateMutationVariables = {id: string}

    /**
 * @summary Save Project as Template
 */
export const useSaveProjectAsTemplate = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveProjectAsTemplate>>, TError,SaveProjectAsTemplateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof saveProjectAsTemplate>>,
        TError,
        SaveProjectAsTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getSaveProjectAsTemplateMutationOptions(options), queryClient);
    }
    /**
 * Upload a file (previously cached via the Shrine upload endpoint) to a project.
 * @summary Attach a file to a project
 */
export const createProjectAttachment = (
    projectId: MaybeRefOrGetter<string>,
    projectAttachmentRequestInput: MaybeRefOrGetter<ProjectAttachmentRequestInput>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);
projectAttachmentRequestInput = toValue(projectAttachmentRequestInput);

      return axiosClient<ProjectAttachment>(
      {url: `/projects/${projectId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectAttachmentRequestInput, signal
    },
      );
    }




export const getCreateProjectAttachmentMutationKey = () => ['createProjectAttachment'] as const;

export const getCreateProjectAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectAttachment>>, TError,CreateProjectAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectAttachment>>, TError,CreateProjectAttachmentMutationVariables, TContext> => {

const mutationKey = getCreateProjectAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectAttachment>>, CreateProjectAttachmentMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectAttachment(projectId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectAttachment>>>
    export type CreateProjectAttachmentMutationBody = ProjectAttachmentRequestInput
    export type CreateProjectAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateProjectAttachmentMutationVariables = {projectId: string;data: ProjectAttachmentRequestInput}

    /**
 * @summary Attach a file to a project
 */
export const useCreateProjectAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectAttachment>>, TError,CreateProjectAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createProjectAttachment>>,
        TError,
        CreateProjectAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectAttachmentMutationOptions(options), queryClient);
    }
    /**
 * Detach a file from a project and delete the uploaded file.
 * @summary Remove a project attachment
 */
export const deleteProjectAttachment = (
    projectId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${projectId}/attachments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProjectAttachmentMutationKey = () => ['deleteProjectAttachment'] as const;

export const getDeleteProjectAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectAttachment>>, TError,DeleteProjectAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectAttachment>>, TError,DeleteProjectAttachmentMutationVariables, TContext> => {

const mutationKey = getDeleteProjectAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectAttachment>>, DeleteProjectAttachmentMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectAttachment(projectId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectAttachment>>>

    export type DeleteProjectAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteProjectAttachmentMutationVariables = {projectId: string;id: string}

    /**
 * @summary Remove a project attachment
 */
export const useDeleteProjectAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectAttachment>>, TError,DeleteProjectAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProjectAttachment>>,
        TError,
        DeleteProjectAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectAttachmentMutationOptions(options), queryClient);
    }
    /**
 * Grant a class teacher view access to a project.
 * @summary Share project with a class teacher
 */
export const createProjectMembership = (
    projectId: MaybeRefOrGetter<string>,
    projectMembershipRequestInput: MaybeRefOrGetter<ProjectMembershipRequestInput>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);
projectMembershipRequestInput = toValue(projectMembershipRequestInput);

      return axiosClient<ProjectMembership>(
      {url: `/projects/${projectId}/memberships`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectMembershipRequestInput, signal
    },
      );
    }




export const getCreateProjectMembershipMutationKey = () => ['createProjectMembership'] as const;

export const getCreateProjectMembershipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectMembership>>, TError,CreateProjectMembershipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectMembership>>, TError,CreateProjectMembershipMutationVariables, TContext> => {

const mutationKey = getCreateProjectMembershipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectMembership>>, CreateProjectMembershipMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  createProjectMembership(projectId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectMembership>>>
    export type CreateProjectMembershipMutationBody = ProjectMembershipRequestInput
    export type CreateProjectMembershipMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateProjectMembershipMutationVariables = {projectId: string;data: ProjectMembershipRequestInput}

    /**
 * @summary Share project with a class teacher
 */
export const useCreateProjectMembership = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectMembership>>, TError,CreateProjectMembershipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createProjectMembership>>,
        TError,
        CreateProjectMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectMembershipMutationOptions(options), queryClient);
    }
    /**
 * List teachers a project has been shared with.
 * @summary List project memberships
 */
export const listProjectMemberships = (
    projectId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);

      return axiosClient<ProjectMembershipsCollection>(
      {url: `/projects/${projectId}/memberships`, method: 'GET', signal
    },
      );
    }




export const getListProjectMembershipsQueryKey = (projectId: MaybeRefOrGetter<string>,) => {
    return [
    'projects',projectId,'memberships'
    ] as const;
    }


export const getListProjectMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(projectId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberships>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectMembershipsQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectMemberships>>> = ({ signal }) => listProjectMemberships(projectId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(projectId) !== null && toValue(projectId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberships>>, TError, TData>
}

export type ListProjectMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectMemberships>>>
export type ListProjectMembershipsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List project memberships
 */

export function useListProjectMemberships<TData = Awaited<ReturnType<typeof listProjectMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 projectId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectMemberships>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectMembershipsQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Class teachers who are not yet shared on the project (excludes the owner and existing memberships).
 * @summary List teachers available to share with
 */
export const listAvailableProjectTeachers = (
    projectId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);

      return axiosClient<ProjectAvailableTeachersCollection>(
      {url: `/projects/${projectId}/memberships/available_teachers`, method: 'GET', signal
    },
      );
    }




export const getListAvailableProjectTeachersQueryKey = (projectId: MaybeRefOrGetter<string>,) => {
    return [
    'projects',projectId,'memberships','available_teachers'
    ] as const;
    }


export const getListAvailableProjectTeachersQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableProjectTeachers>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(projectId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProjectTeachers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAvailableProjectTeachersQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableProjectTeachers>>> = ({ signal }) => listAvailableProjectTeachers(projectId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(projectId) !== null && toValue(projectId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableProjectTeachers>>, TError, TData>
}

export type ListAvailableProjectTeachersQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableProjectTeachers>>>
export type ListAvailableProjectTeachersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List teachers available to share with
 */

export function useListAvailableProjectTeachers<TData = Awaited<ReturnType<typeof listAvailableProjectTeachers>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 projectId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProjectTeachers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableProjectTeachersQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Revoke a teacher's view access to a project.
 * @summary Revoke a project membership
 */
export const deleteProjectMembership = (
    projectId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      projectId = toValue(projectId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/projects/${projectId}/memberships/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteProjectMembershipMutationKey = () => ['deleteProjectMembership'] as const;

export const getDeleteProjectMembershipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMembership>>, TError,DeleteProjectMembershipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMembership>>, TError,DeleteProjectMembershipMutationVariables, TContext> => {

const mutationKey = getDeleteProjectMembershipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectMembership>>, DeleteProjectMembershipMutationVariables> = (props) => {
          const {projectId,id} = props ?? {};

          return  deleteProjectMembership(projectId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectMembership>>>

    export type DeleteProjectMembershipMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteProjectMembershipMutationVariables = {projectId: string;id: string}

    /**
 * @summary Revoke a project membership
 */
export const useDeleteProjectMembership = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectMembership>>, TError,DeleteProjectMembershipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProjectMembership>>,
        TError,
        DeleteProjectMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProjectMembershipMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Pupil
 */
export const deletePupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupils/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePupilMutationKey = () => ['deletePupil'] as const;

export const getDeletePupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,DeletePupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,DeletePupilMutationVariables, TContext> => {

const mutationKey = getDeletePupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePupil>>, DeletePupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deletePupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePupilMutationResult = NonNullable<Awaited<ReturnType<typeof deletePupil>>>

    export type DeletePupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePupilMutationVariables = {id: string}

    /**
 * @summary Delete Pupil
 */
export const useDeletePupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,DeletePupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePupil>>,
        TError,
        DeletePupilMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePupilMutationOptions(options), queryClient);
    }
    /**
 * @summary Pupil Details
 */
export const getPupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Pupil>(
      {url: `/pupils/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPupilQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'pupils',id
    ] as const;
    }


export const getGetPupilQueryOptions = <TData = Awaited<ReturnType<typeof getPupil>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupil>>> = ({ signal }) => getPupil(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData>
}

export type GetPupilQueryResult = NonNullable<Awaited<ReturnType<typeof getPupil>>>
export type GetPupilQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Pupil Details
 */

export function useGetPupil<TData = Awaited<ReturnType<typeof getPupil>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPupilQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Deactivate Pupil
 */
export const deactivatePupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupils/${id}/deactivate`, method: 'PUT', signal
    },
      );
    }




export const getDeactivatePupilMutationKey = () => ['deactivatePupil'] as const;

export const getDeactivatePupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,DeactivatePupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,DeactivatePupilMutationVariables, TContext> => {

const mutationKey = getDeactivatePupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivatePupil>>, DeactivatePupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deactivatePupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof deactivatePupil>>>

    export type DeactivatePupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeactivatePupilMutationVariables = {id: string}

    /**
 * @summary Deactivate Pupil
 */
export const useDeactivatePupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,DeactivatePupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivatePupil>>,
        TError,
        DeactivatePupilMutationVariables,
        TContext
      > => {
      return useMutation(getDeactivatePupilMutationOptions(options), queryClient);
    }
    /**
 * @summary Log out a pupil
 */
export const logoutPupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupils/${id}/logout`, method: 'PUT', signal
    },
      );
    }




export const getLogoutPupilMutationKey = () => ['logoutPupil'] as const;

export const getLogoutPupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutPupil>>, TError,LogoutPupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutPupil>>, TError,LogoutPupilMutationVariables, TContext> => {

const mutationKey = getLogoutPupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutPupil>>, LogoutPupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  logoutPupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutPupilMutationResult = NonNullable<Awaited<ReturnType<typeof logoutPupil>>>

    export type LogoutPupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type LogoutPupilMutationVariables = {id: string}

    /**
 * @summary Log out a pupil
 */
export const useLogoutPupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutPupil>>, TError,LogoutPupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof logoutPupil>>,
        TError,
        LogoutPupilMutationVariables,
        TContext
      > => {
      return useMutation(getLogoutPupilMutationOptions(options), queryClient);
    }
    /**
 * @summary Reactivate Pupil
 */
export const reactivatePupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupils/${id}/reactivate`, method: 'PUT', signal
    },
      );
    }




export const getReactivatePupilMutationKey = () => ['reactivatePupil'] as const;

export const getReactivatePupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,ReactivatePupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,ReactivatePupilMutationVariables, TContext> => {

const mutationKey = getReactivatePupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivatePupil>>, ReactivatePupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  reactivatePupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof reactivatePupil>>>

    export type ReactivatePupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type ReactivatePupilMutationVariables = {id: string}

    /**
 * @summary Reactivate Pupil
 */
export const useReactivatePupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,ReactivatePupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reactivatePupil>>,
        TError,
        ReactivatePupilMutationVariables,
        TContext
      > => {
      return useMutation(getReactivatePupilMutationOptions(options), queryClient);
    }
    /**
 * @summary Regenerate Pupil Token
 */
export const regenerateTokenPupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/pupils/${id}/regenerate_token`, method: 'PUT', signal
    },
      );
    }




export const getRegenerateTokenPupilMutationKey = () => ['regenerateTokenPupil'] as const;

export const getRegenerateTokenPupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,RegenerateTokenPupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,RegenerateTokenPupilMutationVariables, TContext> => {

const mutationKey = getRegenerateTokenPupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateTokenPupil>>, RegenerateTokenPupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  regenerateTokenPupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateTokenPupilMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateTokenPupil>>>

    export type RegenerateTokenPupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RegenerateTokenPupilMutationVariables = {id: string}

    /**
 * @summary Regenerate Pupil Token
 */
export const useRegenerateTokenPupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,RegenerateTokenPupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof regenerateTokenPupil>>,
        TError,
        RegenerateTokenPupilMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateTokenPupilMutationOptions(options), queryClient);
    }
    /**
 * Look up an invite by code. Always returns 200; join eligibility is surfaced inline via is_redeemable and error (the same field and vocabulary redeem returns as a coded error), so the client can tell whether the current user may join before redeeming.
 * @summary Preview a school class invite
 */
export const getSchoolClassInvitePreview = (
    code: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      code = toValue(code);

      return axiosClient<SchoolClassInvitePreview>(
      {url: `/school_class_invites/${code}`, method: 'GET', signal
    },
      );
    }




export const getGetSchoolClassInvitePreviewQueryKey = (code: MaybeRefOrGetter<string>,) => {
    return [
    'school_class_invites',code
    ] as const;
    }


export const getGetSchoolClassInvitePreviewQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolClassInvitePreview>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClassInvitePreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSchoolClassInvitePreviewQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolClassInvitePreview>>> = ({ signal }) => getSchoolClassInvitePreview(code, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(code) !== null && toValue(code) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolClassInvitePreview>>, TError, TData>
}

export type GetSchoolClassInvitePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolClassInvitePreview>>>
export type GetSchoolClassInvitePreviewQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Preview a school class invite
 */

export function useGetSchoolClassInvitePreview<TData = Awaited<ReturnType<typeof getSchoolClassInvitePreview>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClassInvitePreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolClassInvitePreviewQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Redeem an invite code to join a school class as a teacher
 * @summary Redeem a school class invite
 */
export const redeemSchoolClassInvite = (
    code: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      code = toValue(code);

      return axiosClient<SchoolClassInviteRedeemResult>(
      {url: `/school_class_invites/${code}/redeem`, method: 'POST', signal
    },
      );
    }




export const getRedeemSchoolClassInviteMutationKey = () => ['redeemSchoolClassInvite'] as const;

export const getRedeemSchoolClassInviteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | SchoolClassInviteJoinError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemSchoolClassInvite>>, TError,RedeemSchoolClassInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof redeemSchoolClassInvite>>, TError,RedeemSchoolClassInviteMutationVariables, TContext> => {

const mutationKey = getRedeemSchoolClassInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemSchoolClassInvite>>, RedeemSchoolClassInviteMutationVariables> = (props) => {
          const {code} = props ?? {};

          return  redeemSchoolClassInvite(code,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemSchoolClassInviteMutationResult = NonNullable<Awaited<ReturnType<typeof redeemSchoolClassInvite>>>

    export type RedeemSchoolClassInviteMutationError = ErrorType<SchemaValidationErrorResponse | void | SchoolClassInviteJoinError>
    export type RedeemSchoolClassInviteMutationVariables = {code: string}

    /**
 * @summary Redeem a school class invite
 */
export const useRedeemSchoolClassInvite = <TError = ErrorType<SchemaValidationErrorResponse | void | SchoolClassInviteJoinError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemSchoolClassInvite>>, TError,RedeemSchoolClassInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof redeemSchoolClassInvite>>,
        TError,
        RedeemSchoolClassInviteMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemSchoolClassInviteMutationOptions(options), queryClient);
    }
    /**
 * @summary Create SchoolClass
 */
export const createSchoolClass = (
    schoolClassCreateInput: MaybeRefOrGetter<SchoolClassCreateInput>,
 signal?: AbortSignal
) => {
      schoolClassCreateInput = toValue(schoolClassCreateInput);

      return axiosClient<SchoolClass>(
      {url: `/school_classes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassCreateInput, signal
    },
      );
    }




export const getCreateSchoolClassMutationKey = () => ['createSchoolClass'] as const;

export const getCreateSchoolClassMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,CreateSchoolClassMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,CreateSchoolClassMutationVariables, TContext> => {

const mutationKey = getCreateSchoolClassMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolClass>>, CreateSchoolClassMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSchoolClass(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolClass>>>
    export type CreateSchoolClassMutationBody = SchoolClassCreateInput
    export type CreateSchoolClassMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateSchoolClassMutationVariables = {data: SchoolClassCreateInput}

    /**
 * @summary Create SchoolClass
 */
export const useCreateSchoolClass = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,CreateSchoolClassMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSchoolClass>>,
        TError,
        CreateSchoolClassMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSchoolClassMutationOptions(options), queryClient);
    }
    /**
 * @summary List of SchoolClasses
 */
export const listSchoolClasses = (
    params?: MaybeRefOrGetter<ListSchoolClassesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedSchoolClasses>(
      {url: `/school_classes`, method: 'GET',
        params, signal
    },
      );
    }




export const getListSchoolClassesQueryKey = (params?: MaybeRefOrGetter<ListSchoolClassesParams>,) => {
    return [
    'school_classes', ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolClassesQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolClasses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListSchoolClassesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSchoolClassesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolClasses>>> = ({ signal }) => listSchoolClasses(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData>
}

export type ListSchoolClassesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolClasses>>>
export type ListSchoolClassesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of SchoolClasses
 */

export function useListSchoolClasses<TData = Awaited<ReturnType<typeof listSchoolClasses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListSchoolClassesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolClassesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Join SchoolClass
 */
export const joinSchoolClass = (
    schoolClassJoinInput: MaybeRefOrGetter<SchoolClassJoinInput>,
 signal?: AbortSignal
) => {
      schoolClassJoinInput = toValue(schoolClassJoinInput);

      return axiosClient<UserUnion>(
      {url: `/school_classes/join`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassJoinInput, signal
    },
      );
    }




export const getJoinSchoolClassMutationKey = () => ['joinSchoolClass'] as const;

export const getJoinSchoolClassMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,JoinSchoolClassMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,JoinSchoolClassMutationVariables, TContext> => {

const mutationKey = getJoinSchoolClassMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinSchoolClass>>, JoinSchoolClassMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  joinSchoolClass(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof joinSchoolClass>>>
    export type JoinSchoolClassMutationBody = SchoolClassJoinInput
    export type JoinSchoolClassMutationError = ErrorType<void>
    export type JoinSchoolClassMutationVariables = {data: SchoolClassJoinInput}

    /**
 * @summary Join SchoolClass
 */
export const useJoinSchoolClass = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinSchoolClass>>, TError,JoinSchoolClassMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof joinSchoolClass>>,
        TError,
        JoinSchoolClassMutationVariables,
        TContext
      > => {
      return useMutation(getJoinSchoolClassMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete SchoolClass
 */
export const deleteSchoolClass = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/school_classes/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteSchoolClassMutationKey = () => ['deleteSchoolClass'] as const;

export const getDeleteSchoolClassMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,DeleteSchoolClassMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,DeleteSchoolClassMutationVariables, TContext> => {

const mutationKey = getDeleteSchoolClassMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolClass>>, DeleteSchoolClassMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteSchoolClass(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolClass>>>

    export type DeleteSchoolClassMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteSchoolClassMutationVariables = {id: string}

    /**
 * @summary Delete SchoolClass
 */
export const useDeleteSchoolClass = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,DeleteSchoolClassMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSchoolClass>>,
        TError,
        DeleteSchoolClassMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSchoolClassMutationOptions(options), queryClient);
    }
    /**
 * @summary SchoolClass Details
 */
export const getSchoolClass = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SchoolClass>(
      {url: `/school_classes/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetSchoolClassQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'school_classes',id
    ] as const;
    }


export const getGetSchoolClassQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolClass>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSchoolClassQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolClass>>> = ({ signal }) => getSchoolClass(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData>
}

export type GetSchoolClassQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolClass>>>
export type GetSchoolClassQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary SchoolClass Details
 */

export function useGetSchoolClass<TData = Awaited<ReturnType<typeof getSchoolClass>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSchoolClassQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update SchoolClass
 */
export const updateSchoolClass = (
    id: MaybeRefOrGetter<string>,
    schoolClassUpdateInput: MaybeRefOrGetter<SchoolClassUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
schoolClassUpdateInput = toValue(schoolClassUpdateInput);

      return axiosClient<SchoolClass>(
      {url: `/school_classes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassUpdateInput, signal
    },
      );
    }




export const getUpdateSchoolClassMutationKey = () => ['updateSchoolClass'] as const;

export const getUpdateSchoolClassMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,UpdateSchoolClassMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,UpdateSchoolClassMutationVariables, TContext> => {

const mutationKey = getUpdateSchoolClassMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolClass>>, UpdateSchoolClassMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSchoolClass(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolClass>>>
    export type UpdateSchoolClassMutationBody = SchoolClassUpdateInput
    export type UpdateSchoolClassMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateSchoolClassMutationVariables = {id: string;data: SchoolClassUpdateInput}

    /**
 * @summary Update SchoolClass
 */
export const useUpdateSchoolClass = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,UpdateSchoolClassMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSchoolClass>>,
        TError,
        UpdateSchoolClassMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSchoolClassMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Project
 */
export const createProject = (
    id: MaybeRefOrGetter<string>,
    projectRequestInput: MaybeRefOrGetter<ProjectRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
projectRequestInput = toValue(projectRequestInput);

      return axiosClient<Project>(
      {url: `/school_classes/${id}/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectRequestInput, signal
    },
      );
    }




export const getCreateProjectMutationKey = () => ['createProject'] as const;

export const getCreateProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext> => {

const mutationKey = getCreateProjectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, CreateProjectMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createProject(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = ProjectRequestInput
    export type CreateProjectMutationError = ErrorType<void>
    export type CreateProjectMutationVariables = {id: string;data: ProjectRequestInput}

    /**
 * @summary Create Project
 */
export const useCreateProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,CreateProjectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        CreateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Projects
 */
export const listProjects = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<PaginatedProjects>(
      {url: `/school_classes/${id}/projects`, method: 'GET',
        params, signal
    },
      );
    }




export const getListProjectsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectsParams>,) => {
    return [
    'school_classes',id,'projects', ...(params ? [params] : [])
    ] as const;
    }


export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Projects
 */

export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListProjectsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProjectsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Pupil
 */
export const createPupil = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Pupil>(
      {url: `/school_classes/${id}/pupils`, method: 'POST', signal
    },
      );
    }




export const getCreatePupilMutationKey = () => ['createPupil'] as const;

export const getCreatePupilMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,CreatePupilMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,CreatePupilMutationVariables, TContext> => {

const mutationKey = getCreatePupilMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupil>>, CreatePupilMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  createPupil(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof createPupil>>>

    export type CreatePupilMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreatePupilMutationVariables = {id: string}

    /**
 * @summary Create Pupil
 */
export const useCreatePupil = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,CreatePupilMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupil>>,
        TError,
        CreatePupilMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePupilMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Pupils
 */
export const listPupils = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<PaginatedPupils>(
      {url: `/school_classes/${id}/pupils`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPupilsInfiniteQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>,) => {
    return [
    'infinite', 'school_classes',id,'pupils', ...(params ? [params] : [])
    ] as const;
    }

export const getListPupilsQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>,) => {
    return [
    'school_classes',id,'pupils', ...(params ? [params] : [])
    ] as const;
    }


export const getListPupilsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listPupils>>, ListPupilsParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData, QueryKey, ListPupilsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupils>>, QueryKey, ListPupilsParams['page']> = ({ signal, pageParam }) => listPupils(id,{...toValue(params), 'page': pageParam ?? toValue(params)?.['page']}, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData, QueryKey, ListPupilsParams['page']>
}

export type ListPupilsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listPupils>>>
export type ListPupilsInfiniteQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Pupils
 */

export function useListPupilsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listPupils>>, ListPupilsParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData, QueryKey, ListPupilsParams['page']>>, }
 , queryClient?: QueryClient
 ): UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPupilsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export const getListPupilsQueryOptions = <TData = Awaited<ReturnType<typeof listPupils>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupils>>> = ({ signal }) => listPupils(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData>
}

export type ListPupilsQueryResult = NonNullable<Awaited<ReturnType<typeof listPupils>>>
export type ListPupilsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Pupils
 */

export function useListPupils<TData = Awaited<ReturnType<typeof listPupils>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListPupilsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPupilsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Create a new invite link for a school class
 * @summary Create invite link for a school class
 */
export const createSchoolClassInvite = (
    schoolClassId: MaybeRefOrGetter<string>,
    inviteInput?: MaybeRefOrGetter<InviteInput>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
inviteInput = toValue(inviteInput);

      return axiosClient<Invite>(
      {url: `/school_classes/${schoolClassId}/invites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteInput, signal
    },
      );
    }




export const getCreateSchoolClassInviteMutationKey = () => ['createSchoolClassInvite'] as const;

export const getCreateSchoolClassInviteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClassInvite>>, TError,CreateSchoolClassInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolClassInvite>>, TError,CreateSchoolClassInviteMutationVariables, TContext> => {

const mutationKey = getCreateSchoolClassInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolClassInvite>>, CreateSchoolClassInviteMutationVariables> = (props) => {
          const {schoolClassId,data} = props ?? {};

          return  createSchoolClassInvite(schoolClassId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolClassInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolClassInvite>>>
    export type CreateSchoolClassInviteMutationBody = InviteInput | undefined
    export type CreateSchoolClassInviteMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateSchoolClassInviteMutationVariables = {schoolClassId: string;data?: InviteInput}

    /**
 * @summary Create invite link for a school class
 */
export const useCreateSchoolClassInvite = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClassInvite>>, TError,CreateSchoolClassInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSchoolClassInvite>>,
        TError,
        CreateSchoolClassInviteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSchoolClassInviteMutationOptions(options), queryClient);
    }
    /**
 * List all non-revoked invite links for a school class
 * @summary List invites for a school class
 */
export const listSchoolClassInvites = (
    schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassInvitesParams>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
params = toValue(params);

      return axiosClient<PaginatedInvites>(
      {url: `/school_classes/${schoolClassId}/invites`, method: 'GET',
        params, signal
    },
      );
    }




export const getListSchoolClassInvitesQueryKey = (schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassInvitesParams>,) => {
    return [
    'school_classes',schoolClassId,'invites', ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolClassInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolClassInvites>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassInvitesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassInvites>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSchoolClassInvitesQueryKey(schoolClassId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolClassInvites>>> = ({ signal }) => listSchoolClassInvites(schoolClassId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(schoolClassId) !== null && toValue(schoolClassId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassInvites>>, TError, TData>
}

export type ListSchoolClassInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolClassInvites>>>
export type ListSchoolClassInvitesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List invites for a school class
 */

export function useListSchoolClassInvites<TData = Awaited<ReturnType<typeof listSchoolClassInvites>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassInvitesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassInvites>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolClassInvitesQueryOptions(schoolClassId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Revoke (soft-delete) an invite link
 * @summary Revoke an invite link
 */
export const deleteSchoolClassInvite = (
    schoolClassId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/school_classes/${schoolClassId}/invites/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteSchoolClassInviteMutationKey = () => ['deleteSchoolClassInvite'] as const;

export const getDeleteSchoolClassInviteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClassInvite>>, TError,DeleteSchoolClassInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClassInvite>>, TError,DeleteSchoolClassInviteMutationVariables, TContext> => {

const mutationKey = getDeleteSchoolClassInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolClassInvite>>, DeleteSchoolClassInviteMutationVariables> = (props) => {
          const {schoolClassId,id} = props ?? {};

          return  deleteSchoolClassInvite(schoolClassId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolClassInviteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolClassInvite>>>

    export type DeleteSchoolClassInviteMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteSchoolClassInviteMutationVariables = {schoolClassId: string;id: string}

    /**
 * @summary Revoke an invite link
 */
export const useDeleteSchoolClassInvite = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClassInvite>>, TError,DeleteSchoolClassInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSchoolClassInvite>>,
        TError,
        DeleteSchoolClassInviteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSchoolClassInviteMutationOptions(options), queryClient);
    }
    /**
 * Revoke the given invite and create a new one. Inherits expires_at and max_uses unless overridden in the body.
 * @summary Regenerate an invite link
 */
export const regenerateSchoolClassInvite = (
    schoolClassId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    inviteInput?: MaybeRefOrGetter<InviteInput>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
id = toValue(id);
inviteInput = toValue(inviteInput);

      return axiosClient<Invite>(
      {url: `/school_classes/${schoolClassId}/invites/${id}/regenerate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteInput, signal
    },
      );
    }




export const getRegenerateSchoolClassInviteMutationKey = () => ['regenerateSchoolClassInvite'] as const;

export const getRegenerateSchoolClassInviteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSchoolClassInvite>>, TError,RegenerateSchoolClassInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateSchoolClassInvite>>, TError,RegenerateSchoolClassInviteMutationVariables, TContext> => {

const mutationKey = getRegenerateSchoolClassInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateSchoolClassInvite>>, RegenerateSchoolClassInviteMutationVariables> = (props) => {
          const {schoolClassId,id,data} = props ?? {};

          return  regenerateSchoolClassInvite(schoolClassId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateSchoolClassInviteMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateSchoolClassInvite>>>
    export type RegenerateSchoolClassInviteMutationBody = InviteInput | undefined
    export type RegenerateSchoolClassInviteMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type RegenerateSchoolClassInviteMutationVariables = {schoolClassId: string;id: string;data?: InviteInput}

    /**
 * @summary Regenerate an invite link
 */
export const useRegenerateSchoolClassInvite = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateSchoolClassInvite>>, TError,RegenerateSchoolClassInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof regenerateSchoolClassInvite>>,
        TError,
        RegenerateSchoolClassInviteMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateSchoolClassInviteMutationOptions(options), queryClient);
    }
    /**
 * Leave a shared classroom by discarding the user's own membership
 * @summary Leave a shared classroom
 */
export const leaveSharedClassroom = (
    schoolClassId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);

      return axiosClient<void>(
      {url: `/school_classes/${schoolClassId}/leave`, method: 'POST', signal
    },
      );
    }




export const getLeaveSharedClassroomMutationKey = () => ['leaveSharedClassroom'] as const;

export const getLeaveSharedClassroomMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveSharedClassroom>>, TError,LeaveSharedClassroomMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof leaveSharedClassroom>>, TError,LeaveSharedClassroomMutationVariables, TContext> => {

const mutationKey = getLeaveSharedClassroomMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveSharedClassroom>>, LeaveSharedClassroomMutationVariables> = (props) => {
          const {schoolClassId} = props ?? {};

          return  leaveSharedClassroom(schoolClassId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveSharedClassroomMutationResult = NonNullable<Awaited<ReturnType<typeof leaveSharedClassroom>>>

    export type LeaveSharedClassroomMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type LeaveSharedClassroomMutationVariables = {schoolClassId: string}

    /**
 * @summary Leave a shared classroom
 */
export const useLeaveSharedClassroom = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveSharedClassroom>>, TError,LeaveSharedClassroomMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof leaveSharedClassroom>>,
        TError,
        LeaveSharedClassroomMutationVariables,
        TContext
      > => {
      return useMutation(getLeaveSharedClassroomMutationOptions(options), queryClient);
    }
    /**
 * Add a teacher to a school class
 * @summary Add teacher to school class
 */
export const addTeacherToSchoolClass = (
    schoolClassId: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<AddTeacherToSchoolClassParams>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
params = toValue(params);

      return axiosClient<SchoolClassMembership>(
      {url: `/school_classes/${schoolClassId}/memberships`, method: 'POST',
        params, signal
    },
      );
    }




export const getAddTeacherToSchoolClassMutationKey = () => ['addTeacherToSchoolClass'] as const;

export const getAddTeacherToSchoolClassMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTeacherToSchoolClass>>, TError,AddTeacherToSchoolClassMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addTeacherToSchoolClass>>, TError,AddTeacherToSchoolClassMutationVariables, TContext> => {

const mutationKey = getAddTeacherToSchoolClassMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTeacherToSchoolClass>>, AddTeacherToSchoolClassMutationVariables> = (props) => {
          const {schoolClassId,params} = props ?? {};

          return  addTeacherToSchoolClass(schoolClassId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTeacherToSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof addTeacherToSchoolClass>>>

    export type AddTeacherToSchoolClassMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type AddTeacherToSchoolClassMutationVariables = {schoolClassId: string;params: AddTeacherToSchoolClassParams}

    /**
 * @summary Add teacher to school class
 */
export const useAddTeacherToSchoolClass = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTeacherToSchoolClass>>, TError,AddTeacherToSchoolClassMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addTeacherToSchoolClass>>,
        TError,
        AddTeacherToSchoolClassMutationVariables,
        TContext
      > => {
      return useMutation(getAddTeacherToSchoolClassMutationOptions(options), queryClient);
    }
    /**
 * List all memberships of teachers in a school class
 * @summary List memberships of teachers in school class
 */
export const listSchoolClassMemberships = (
    schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassMembershipsParams>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
params = toValue(params);

      return axiosClient<PaginatedSchoolClassMemberships>(
      {url: `/school_classes/${schoolClassId}/memberships`, method: 'GET',
        params, signal
    },
      );
    }




export const getListSchoolClassMembershipsQueryKey = (schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassMembershipsParams>,) => {
    return [
    'school_classes',schoolClassId,'memberships', ...(params ? [params] : [])
    ] as const;
    }


export const getListSchoolClassMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolClassMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassMembershipsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassMemberships>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSchoolClassMembershipsQueryKey(schoolClassId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolClassMemberships>>> = ({ signal }) => listSchoolClassMemberships(schoolClassId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(schoolClassId) !== null && toValue(schoolClassId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassMemberships>>, TError, TData>
}

export type ListSchoolClassMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolClassMemberships>>>
export type ListSchoolClassMembershipsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List memberships of teachers in school class
 */

export function useListSchoolClassMemberships<TData = Awaited<ReturnType<typeof listSchoolClassMemberships>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 schoolClassId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ListSchoolClassMembershipsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClassMemberships>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchoolClassMembershipsQueryOptions(schoolClassId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Discard teachers from a school class by soft-deleting their memberships
 * @summary Discard memberships from school class
 */
export const discardSchoolClassMemberships = (
    schoolClassId: MaybeRefOrGetter<string>,
    schoolClassMembershipsInput: MaybeRefOrGetter<SchoolClassMembershipsInput>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
schoolClassMembershipsInput = toValue(schoolClassMembershipsInput);

      return axiosClient<void>(
      {url: `/school_classes/${schoolClassId}/memberships/discard`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassMembershipsInput, signal
    },
      );
    }




export const getDiscardSchoolClassMembershipsMutationKey = () => ['discardSchoolClassMemberships'] as const;

export const getDiscardSchoolClassMembershipsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardSchoolClassMemberships>>, TError,DiscardSchoolClassMembershipsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof discardSchoolClassMemberships>>, TError,DiscardSchoolClassMembershipsMutationVariables, TContext> => {

const mutationKey = getDiscardSchoolClassMembershipsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardSchoolClassMemberships>>, DiscardSchoolClassMembershipsMutationVariables> = (props) => {
          const {schoolClassId,data} = props ?? {};

          return  discardSchoolClassMemberships(schoolClassId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardSchoolClassMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof discardSchoolClassMemberships>>>
    export type DiscardSchoolClassMembershipsMutationBody = SchoolClassMembershipsInput
    export type DiscardSchoolClassMembershipsMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DiscardSchoolClassMembershipsMutationVariables = {schoolClassId: string;data: SchoolClassMembershipsInput}

    /**
 * @summary Discard memberships from school class
 */
export const useDiscardSchoolClassMemberships = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardSchoolClassMemberships>>, TError,DiscardSchoolClassMembershipsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof discardSchoolClassMemberships>>,
        TError,
        DiscardSchoolClassMembershipsMutationVariables,
        TContext
      > => {
      return useMutation(getDiscardSchoolClassMembershipsMutationOptions(options), queryClient);
    }
    /**
 * Undiscard teachers from a school class by restoring their memberships
 * @summary Undiscard memberships from school class
 */
export const undiscardSchoolClassMemberships = (
    schoolClassId: MaybeRefOrGetter<string>,
    schoolClassMembershipsInput: MaybeRefOrGetter<SchoolClassMembershipsInput>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);
schoolClassMembershipsInput = toValue(schoolClassMembershipsInput);

      return axiosClient<void>(
      {url: `/school_classes/${schoolClassId}/memberships/undiscard`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schoolClassMembershipsInput, signal
    },
      );
    }




export const getUndiscardSchoolClassMembershipsMutationKey = () => ['undiscardSchoolClassMemberships'] as const;

export const getUndiscardSchoolClassMembershipsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>, TError,UndiscardSchoolClassMembershipsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>, TError,UndiscardSchoolClassMembershipsMutationVariables, TContext> => {

const mutationKey = getUndiscardSchoolClassMembershipsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>, UndiscardSchoolClassMembershipsMutationVariables> = (props) => {
          const {schoolClassId,data} = props ?? {};

          return  undiscardSchoolClassMemberships(schoolClassId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UndiscardSchoolClassMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>>
    export type UndiscardSchoolClassMembershipsMutationBody = SchoolClassMembershipsInput
    export type UndiscardSchoolClassMembershipsMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UndiscardSchoolClassMembershipsMutationVariables = {schoolClassId: string;data: SchoolClassMembershipsInput}

    /**
 * @summary Undiscard memberships from school class
 */
export const useUndiscardSchoolClassMemberships = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>, TError,UndiscardSchoolClassMembershipsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof undiscardSchoolClassMemberships>>,
        TError,
        UndiscardSchoolClassMembershipsMutationVariables,
        TContext
      > => {
      return useMutation(getUndiscardSchoolClassMembershipsMutationOptions(options), queryClient);
    }
    /**
 * @summary Log out all pupils of a school class
 */
export const logoutSchoolClassPupils = (
    schoolClassId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      schoolClassId = toValue(schoolClassId);

      return axiosClient<void>(
      {url: `/school_classes/${schoolClassId}/pupils/logout`, method: 'POST', signal
    },
      );
    }




export const getLogoutSchoolClassPupilsMutationKey = () => ['logoutSchoolClassPupils'] as const;

export const getLogoutSchoolClassPupilsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutSchoolClassPupils>>, TError,LogoutSchoolClassPupilsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutSchoolClassPupils>>, TError,LogoutSchoolClassPupilsMutationVariables, TContext> => {

const mutationKey = getLogoutSchoolClassPupilsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutSchoolClassPupils>>, LogoutSchoolClassPupilsMutationVariables> = (props) => {
          const {schoolClassId} = props ?? {};

          return  logoutSchoolClassPupils(schoolClassId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutSchoolClassPupilsMutationResult = NonNullable<Awaited<ReturnType<typeof logoutSchoolClassPupils>>>

    export type LogoutSchoolClassPupilsMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type LogoutSchoolClassPupilsMutationVariables = {schoolClassId: string}

    /**
 * @summary Log out all pupils of a school class
 */
export const useLogoutSchoolClassPupils = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutSchoolClassPupils>>, TError,LogoutSchoolClassPupilsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof logoutSchoolClassPupils>>,
        TError,
        LogoutSchoolClassPupilsMutationVariables,
        TContext
      > => {
      return useMutation(getLogoutSchoolClassPupilsMutationOptions(options), queryClient);
    }
